type TouchPoint = {
  clientX: number
  clientY: number
}

type PointerEventShape = {
  clientX: number
  clientY: number
  changedTouches?: TouchPoint[]
}

const elementFromEvent = (e: PointerEventShape) => {
  const touch = e.changedTouches?.[0]
  const point = touch || e
  return document.elementFromPoint(point.clientX, point.clientY)
}

const getEventTarget = (e: PointerEventShape, predicate: (elem: Element) => boolean) => {
  let target = elementFromEvent(e)
  while (target?.parentElement) {
    if (predicate(target)) {
      return target
    }
    target = target.parentElement
  }
  return undefined
}

const isEventOn = (e: PointerEventShape, el: Element | null | undefined) => {
  const found = getEventTarget(e, (elem) => elem === el)
  return found != null
}

export { isEventOn }
export { getEventTarget }
export { elementFromEvent }